import React from 'react';

interface InputFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  multiline?: boolean;
  type?: 'text' | 'email';
  error?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  id,
  label,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  multiline = false,
  type = 'text',
  error,
}) => {
  const sharedClassName = `mt-1 w-full rounded-lg border px-3 py-2 text-sm outline-none transition ${
    error ? 'border-red-400 focus:border-red-500' : 'border-slate-300 focus:border-slate-500'
  } ${disabled ? 'bg-slate-100 text-slate-500' : 'bg-white text-slate-900'}`;

  return (
    <label htmlFor={id} className="block">
      <span className="text-sm font-medium text-slate-700">
        {label}
        {required ? <span className="text-red-500"> *</span> : null}
      </span>
      {multiline ? (
        <textarea
          id={id}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          rows={4}
          className={sharedClassName}
        />
      ) : (
        <input
          id={id}
          type={type}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          disabled={disabled}
          className={sharedClassName}
        />
      )}
      {error ? <span className="mt-1 block text-xs text-red-600">{error}</span> : null}
    </label>
  );
};

export default InputField;
